import { ComplexAttributeConverter } from 'lit';

export const booleanConverter = {
  fromAttribute: (value: string): boolean => {
    return value === 'true' || value === '';
  },
  toAttribute: (value: boolean): string => {
    return value ? 'true' : 'false';
  }
}

export function enumConverter<T extends Record<string, string | number>>(enumObj: T): ComplexAttributeConverter<T[keyof T] | null, string> {
  return {
    fromAttribute: (attr: string | null): T[keyof T] | null => {
      if (!attr) return null;
      return enumObj[attr as keyof T] ?? null;
    },
    toAttribute: (value: T[keyof T] | null): string | null => {
      if (value == null) return null;
      const entry = Object.entries(enumObj).find(([_, v]) => v === value);
      return entry ? entry[0] : null;
    }
  };
}